import {NgModule} from "@angular/core";
import {RouterModule} from "@angular/router";

import {BsDropdownModule} from 'ngx-bootstrap';

import {BasicLayoutComponent} from "./basicLayout.component";
import {BlankLayoutComponent} from "./blankLayout.component";
import {NavigationComponent} from "./../navigation/navigation.component";
import {FooterComponent} from "./../footer/footer.component";
import {TopNavbarComponent} from "./../topnavbar/topnavbar.component";
import {TopNavigationNavbarComponent} from "./../topnavbar/topnavigationnavbar.component";
import {CommonModule} from '@angular/common';
import {SpinnerComponent} from "../../spinner/spinner.component";
import {SpinnerService} from "../../spinner/spinner.service";
import {TranslateModule} from "@ngx-translate/core";
import {LoginModule} from "../../../pages/login/login.module";
import {TopNavigationLayoutComponent} from "./topNavigationLayout.component";

@NgModule({
  declarations: [
    FooterComponent,
    BasicLayoutComponent,
    BlankLayoutComponent,
    NavigationComponent,
    TopNavbarComponent,
    TopNavigationNavbarComponent,
    SpinnerComponent,
    TopNavigationLayoutComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    BsDropdownModule.forRoot(),
    TranslateModule,
  ],
  providers: [
    SpinnerService
  ],
  exports: [
    FooterComponent,
    BasicLayoutComponent,
    BlankLayoutComponent,
    NavigationComponent,
    TopNavbarComponent,
    TopNavigationNavbarComponent,
    SpinnerComponent,
    TopNavigationLayoutComponent
  ],
})

export class LayoutsModule {}
